<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "ParametervarSect", "label": i18n.t('component.SysParameter.ParametervarSect.label') },
                    { "key": "ParametervarName", "label": i18n.t('component.SysParameter.ParametervarName.label') },
                    { "key": "ParametervarValue", "label": i18n.t('component.SysParameter.ParametervarValue.label') }
                ]
            },
            header() {
                return i18n.t('component.SysParameter.recHeader')
            }
        },
        data() {

            return {
                name: "SysParameter",
                pkColumn: "SysParameterId",
                parent: {}
            };
        }
    }
</script>